$(document).ready(function() {
	//
	// Global, one time, functions
	//
	var $body = $('body');
	$body.removeClass("preload");

	var focusLockOptions = {
		element: null,
		focusable: null,
		firstFocusable: null,
		lastFocusable: null,
		triggerFocus: null,
	};

	// FitVids
	$('.wysiwyg').fitVids();

	// Navigation button
	$('button.nav_close').on('click', function(){
		var $this = $(this);
		if ($this.hasClass('x')) {
			closeMobileNav();
		} else {
			$this.addClass('x');
			$('nav.global').addClass('mobile_open');
			$body.addClass('menu_open');
			// Trap focus
			trapFocus(document.getElementById('main_header'));
			// Set aria label to open
			$this.attr('aria-expanded', true);
		}
	});
	function closeMobileNav() {
		if ( $('button.nav_close').hasClass('x') ) {
			$('button.nav_close').removeClass('x');
			$('nav.global').removeClass('mobile_open');
			$body.removeClass('menu_open');
			// Remove focus trap
			releaseFocus(document.getElementById('main_header'));
			// Set aria label to closed
			$('button.nav_close').attr('aria-expanded', false);
		}
	}

	//Banner Play Button
	$body.on('click', '.play-button', function(e) {
		e.preventDefault();

		var $overlay = $(this).parent('.banner');

		$overlay.css({
			'z-index': -1,
			'opacity': 0
		});
		$overlay.siblings('iframe').css({
			'z-index': 1,
			'opacity': 1,
			'visibility': 'visible'
		});
		// Pause HTML5 video background.
		var $videobg = $(this).parents('.fc--banner').find('video');
		if ($videobg.length != 0) {
			$videobg.get(0).pause();
		}
		// Play vimeo video
		var player = new Vimeo.Player($overlay.siblings('iframe'));
		player.play();

	});

	// Modal Stuff
	var $close_modal = $('[data-modal-close]'),
	$body = $body;

	$body.on('click', '.open_modal', function(e) {
		e.preventDefault();
		e.stopPropagation();

		// Set Vars
		var $this = $(this);

		// Update history api.
		var url = window.location.pathname + $this.attr('href');
		history.replaceState({ page: url }, null, url);

		// Open modal
		openModal($this);
	});

	$close_modal.on('click', function(e) {
		// Make sure they are not clicking a normal link in the modal.
		if ( e.target.hasAttribute('data-modal-close') ) {
			e.preventDefault();
			e.stopPropagation(); // Stops background from affecting if close above it was clicked.

			// Update history api.
			var url = window.location.pathname;
			history.replaceState({ page: url }, null, url);

			// Close modal
			closeModal();
		}
	});

	function openModal($this){
		if ( $this.hasClass('grid--item__video') || $this.hasClass('callout__video') ) {
			var video_url = $this.attr('video-modal');

			var iframe = '<div class="iframe"><iframe src="https://player.vimeo.com/video/'
			+ video_url + '" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div><!-- /.iframe -->';

			$('.modal').find('.modal__content').html(iframe);

			if (!Modernizr.touchevents) {
				// Play vimeo video
				var modal_player = new Vimeo.Player($('.modal').find('iframe'));
				modal_player.play();
			}

		} else if ( $this.hasClass('grid--item__image') || $this.hasClass('callout__image') ) {
			var image_url = $this.attr('image-modal');

			$('.modal').addClass('static-asset').find('.modal__content').html('<img class="full_image_modal" src="'+image_url+'" alt="">');

		} else if ( $this.hasClass('jobs') ) {
			var data = $this.attr('data-modal'),
			id = parseInt(data),
			title = modal_content[id][0],
			copy = modal_content[id][1];

			$('.modal').addClass('sticky-top').find('.modal__content').html('<div class="column column--title"><h2>' + title + '</h2></div><!-- /.column column--title <--><div class="column column--copy">' + copy + '</div><!-- /.column column--copy --></-->');

			// Start validation for forms.
			// Form Required Fields
			var $form = $('.modal form');
			$form.bind('submit', function( evt ){
				var emptyInput = false;

				$children = $(this).find('.required input');
				$children.each(function(){
					if ( this.value == "" ) {
						emptyInput = true;
					}
				});

				if ( emptyInput ) {
					alert("Please complete all required fields.");
					evt.preventDefault();
				}
			});

		} else if ( $this.hasClass('team__member') ) {
			var data = $this.attr('data-modal'),
			id = parseInt(data),
			name = modal_content_team[id][0],
			title = modal_content_team[id][1],
			img = modal_content_team[id][2],
			bio = modal_content_team[id][3];

			$('.modal').addClass('sticky-top').find('.modal__content').html('<div class="column column--title"><div class="image"><img src="' + img + '" alt=""></div><!-- /.image <--><div class="title"><h2>' + name + '</h2><h4>' + title + '</h4></div><!-- /.title --></--></div><!-- /.column column--title <--><div class="column column--copy">' + bio + '</div><!-- /.column column--copy --></-->');

		}

		$body.addClass('modal--active');

		// Trap focus
		trapFocus(document.getElementById('modal'));
	}

	function closeModal(){
		$body.removeClass('modal--active');
		$('.modal').find('.modal__content').html('');
		$('.modal').removeClass('sticky-top').removeClass('static-asset');

		// Remove focus trap
		releaseFocus(document.getElementById('modal'));
	}


	// Clip path support check.
	var clipPathIsSupported = function () {
		var base = 'clipPath',
		prefixes = [ 'webkit', 'moz'],
		properties = [ base ],
		testElement = document.createElement( 'testelement' ),
		attribute = 'polygon(50% 0%, 0% 100%, 100% 100%)';

		// Push the prefixed properties into the array of properties.
		for ( var i = 0, l = prefixes.length; i < l; i++ ) {
			var prefixedProperty = prefixes[i] + base.charAt( 0 ).toUpperCase() + base.slice( 1 ); // remember to capitalize!
			properties.push( prefixedProperty );
		}

		// Interate over the properties and see if they pass two tests.
		for ( var i = 0, l = properties.length; i < l; i++ ) {
			var property = properties[i];

			// First, they need to even support clip-path (IE <= 11 does not)...
			if ( testElement.style[property] === '' ) {

				// Second, we need to see what happens when we try to create a CSS shape...
				testElement.style[property] = attribute;
				if ( testElement.style[property] !== '' ) {
					return true;
				}
			}
		}

		return false;
	};

	if ( clipPathIsSupported() ) {
		$('html').addClass('clip-path');
	} else {
		$('html').addClass('no-clip-path');
	}

	function trapFocus(element) {
		// Check if focus is locked? Release if so.
		if (focusLockOptions.element !== null) releaseFocus();
		// Set global options
		focusLockOptions.element = element;
		focusLockOptions.focusable = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
		focusLockOptions.firstFocusable = focusLockOptions.focusable[0];
		focusLockOptions.lastFocusable = focusLockOptions.focusable[focusLockOptions.focusable.length - 1];
		focusLockOptions.triggerFocus = document.activeElement;
		// Start listener
		focusLockOptions.element.addEventListener('keydown', focusKeyDown);
		// Set focus to first element
		focusLockOptions.firstFocusable.focus();
	}
	function releaseFocus() {
		// Return focus
		focusLockOptions.triggerFocus.focus();
		// Release listener
		focusLockOptions.element.removeEventListener('keydown', focusKeyDown);
		// Reset globals
		focusLockOptions = {
			element: null,
			focusable: null,
			firstFocusable: null,
			lastFocusable: null,
			triggerFocus: null,
		};
	}

	function focusKeyDown(evt) {
		if (evt.key !== 'Tab' || evt.keyCode !== 9) return;

		if ( evt.shiftKey ) /* shift + tab */ {
			if (document.activeElement === focusLockOptions.firstFocusable) {
				focusLockOptions.lastFocusable.focus();
				evt.preventDefault();
			}
		} else /* tab */ {
			if (document.activeElement === focusLockOptions.lastFocusable) {
				focusLockOptions.firstFocusable.focus();
				evt.preventDefault();
			}
		}
	}

	//
	// Per page functions
	//

	function initHtml() {
		// Work scroll init
		if ($('.fc--work').length > 0) LoadMore.init();
		if ($('.fc--blog_posts').length > 0) LoadMore.init();
		// Scroll handler init
		scrollHandler.init();

		// Make external links open in new tab/window
		$('a').each(function() {
			if( location.hostname === this.hostname || !this.hostname.length ) {
				$(this).addClass('local');
			} else {
				$(this).addClass('external');
				$(this).attr('target', '_blank');
			}
		});

		// Animated heading scripts
		var $targets = $('.animated-title');
		setTimeout(function() {
			$targets.addClass('loaded');
		}, 100);
		setTimeout(function() {
			$targets.addClass('open');
		}, 250);

		// Check if the current nav item is highlighted
		$('header li.menu-item').each(function(i,v){
			var $v = $(v);
			if ($v.hasClass('current-menu-item') && v.getElementsByTagName('a')[0].pathname != location.pathname || location.pathname.match(/^\/work/i) && v.getElementsByTagName('a')[0].pathname == '/') {
				$v.removeClass('current-menu-item current_page_item');
			}
			// Make active menu items, active.
			if ( v.getElementsByTagName('a')[0].pathname == location.pathname ||
				 v.getElementsByTagName('a')[0].pathname == '/' && location.pathname.match(/^\/work/i) ) {
				$v.addClass('current-menu-item current_page_item');
			}
		});

		// Check if we have a map to init
		if ($('#google_map').length > 0) {
			var map;

			map = new GMaps({
				el: '#google_map',
				lat: 44.977991,
				lng: -93.268228,
				scrollwheel:false,
				zoom: 15,
				zoomControl : true,
				zoomControlOptions : {
					position: google.maps.ControlPosition.RIGHT_BOTTOM
				},
				panControl : false,
				streetViewControl : false,
				mapTypeControl: false,
				overviewMapControl: false,
				clickable: false
			});

			var bbdoIcon = {
				url: '/wp-content/themes/bbdompls_v2/_a/images/map_marker.png',
				scaledSize: new google.maps.Size(125,60),
				anchor: new google.maps.Point(60,35)
			};
			map.addMarker({
				lat: 44.977991,
				lng: -93.268228,
				icon: bbdoIcon,
				animation: google.maps.Animation.DROP,
			});


			var styles = [{"featureType":"landscape","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"stylers":[{"hue":"#00aaff"},{"saturation":-100},{"gamma":2.15},{"lightness":12}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"lightness":24}]},{"featureType":"road","elementType":"geometry","stylers":[{"lightness":57}]}];

			map.addStyle({
				styledMapName: "BBDO Map",
				styles: styles,
				mapTypeId: "map_style"
			});

			map.setStyle("map_style");
		}

		// If URL has a hash, see if it matches a modal option.
		if (window.location.hash) {
			var hash = window.location.hash;
			$modal_link = $('.open_modal[href="'+hash+'"]');
			if ($modal_link.length > 0) openModal($('.open_modal[href="'+hash+'"]'));
		}
	}
	// Trigger on static load
	initHtml();

	// Trigger work clip paths on mobile
	var $fw_ele = $('.featured-post');
	$(document).on('scroll', function() {
		if (window.matchMedia("(max-width: 768px)").matches) {
			$fw_ele.addClass('js_reveal');
			/* the viewport is at least 400 pixels wide */
		} else {
			$fw_ele.removeClass('js_reveal');
		}
	});

	// AJAX page loads
	var pageChanger = {
		changePage: function (evt) {
			// If the link is internal, catch it.
			if( !this.getAttribute('href').match(/^#/) && location.hostname === this.hostname || !this.hostname.length ) {
				// Check if it is a mailto.
				if (!this.getAttribute('href').match(/^mailto/) && !$(this).hasClass('force') && !this.getAttribute('href').match(/\/careers\/./) ) {
					// Prevent links from loading
					evt.preventDefault();
					// If meta key is used, open the link in a new window instead, just to be nice
					if (evt.metaKey) {
						window.open(evt.currentTarget.pathname,'_blank');
					} else {
						// If not the current page, continue
						if ( this.pathname != location.pathname ) {
							// Update the current history state with the scroll position before we leave
							pageChanger.updateScrollState();
							// Load the requested HTML
							pageChanger.loadHTML( evt.currentTarget.pathname );
						}
						// Close nav
						closeMobileNav();
					}
				}
			}
		},

		updateScrollState: function () {
			var url = window.location.pathname;
			if (window.location.hash) url += window.location.hash;
			history.replaceState({ page: url, scrollTop: $(window).scrollTop() }, document.title, url);
		},

		popStateChange: function (evt) {
			var state = evt.originalEvent.state;
			if ( state !== null ) {
				if ( state.page !== undefined && currentPage !== state.page ) {
					// Stop the browser from restoring scroll position, we handle that
					if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
					// TODO - Create a custom array for scroll levels, updated on scroll, using UIDs saved to each state.
					// Load the page from the state pop
					pageChanger.loadHTML(state.page, true, state.scrollTop);
					// Check if we need to close a modal.
					if ($body.hasClass('modal--active')) closeModal();
				}
			}
		},

		loadHTML: function (url, isPop, scrollTop) {
			console.log(url);
			// Load HTML
			$.getJSON('/wp-json/bbdo/v1/slug/' + url.replace(/^\//, '')).done(function(data) {
				Pace.restart();

				var dataObj = JSON.parse(data);
				// Update the history API if not a popstate change
				if (!isPop) history.pushState({ page: url }, dataObj.seo.yoast_wpseo_title, url);

				currentPage = url;
				// Update page title
				document.title = dataObj.seo.yoast_wpseo_title;
				// Update body class page ID for load more
				var bodyEle = document.getElementsByTagName('body')[0];

				if (dataObj.type != 'page') {
					bodyEle.className = bodyEle.className.replace(/(page-id-|postid-|error)[0-9]+/ig, 'postid-' + dataObj.id);
				} else {
					bodyEle.className = bodyEle.className.replace(/(page-id-|postid-|error)[0-9]+/ig, 'page-id-' + dataObj.id);
				}

				// Build HTML
				var newContent = document.createElement('section');
				newContent.className = 'content_section--'+ dataObj.type +' content_section loading';
				if (dataObj.isHome) {
					newContent.className = newContent.className + ' home-content';
				}
				newContent.innerHTML = dataObj.content;

				// Display HTML
				var $oldContent = $('section.content_section.current');
				var $newContent = $(newContent).insertAfter($oldContent);

				// Once pace detects the load is finished, animate in.
				Pace.once('done', function(){
					// If this not a pop state, set scroll top to 0;
					if (scrollTop === undefined) scrollTop = 0;

					// Animate new content in to view
					$newContent.animate({ transform: 'translateX(0%)' }, { duration: 600, easing: "easeInHard", complete: function() {
						// Check where the page should load at
						// if (isPop && scrollTop !== undefined) {
						// 	// Load content at state's scrollTop
						// 	// TODO - Animate this better.
						// 	window.scrollTo(0, scrollTop);
						// } else {
						// 	// Load content at top for new states
						// 	window.scrollTo(0, 0);
						// }
						window.scrollTo(0, 0);
						// Remove old content
						$oldContent.remove();
						// Make the new content the current content
						$newContent.removeClass('loading').addClass('current');
						// Fire a GA page view event, if loaded
						if (ga) ga('send', 'pageview', location.pathname);
						// Init the HTML
						initHtml();
					}});
				});
			});
		}
	};


	if (true) {
		// Init Vars
		var currentPage;
		// Apply current class to content section of server loaded page, for layered page load animation
		$('section.content_section').addClass('current');
		// Catch link clicks
		$body.on('click', 'a', pageChanger.changePage);
		// Catch other pop states
		$(window).bind('popstate', pageChanger.popStateChange);
		// Init the current state -- Needed so back button work going to inital page.
		pageChanger.updateScrollState();
		currentPage = location.pathname;
	}
});
